import { createContext, useContext } from "react";

import { TimePeriod, TimeRange } from "@smart/itops-sb-design-system-dom";

import { HomeTabKey } from "./utils";

export type FilterSync = {
  tabKey: HomeTabKey;
  period: TimePeriod;
  range?: TimeRange;
  nonce: number;
};

export const FilterSyncContext = createContext<FilterSync | null>(null);

export const useFilterSync = () => useContext(FilterSyncContext);
